module.exports = __webpack_public_path__ + "img/47.3af37e86.png";